module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_feature03-e8fbf818e7aa042ab4be6564e51ca0ef.jpg";